import classNames from 'classnames';
import { useTranslations } from 'utils';
import { ReactComponent as BackIcon } from './assets/ico-arrow-back.svg';

import './Back.scss';

type BackProps = {
  className?: string;
  onClick?: () => void;
};

const Back = ({ onClick, className }: BackProps) => {
  const i18n = useTranslations();

  return (
    <button
      onClick={onClick}
      className={classNames('Back', className)}
      data-testid="backBtn"
    >
      <BackIcon />
      {i18n.t('checkout.instructions.back')}
    </button>
  );
};

export { Back };
